import React from 'react';

interface SlowTextProps {
    speed: number;
    text: string;
}

const SlowText = (props: SlowTextProps) => {
    const { speed, text, splitText } = props;
    const [placeholder, setPlaceholder] = React.useState(text.split(" ")[0]);

    const index = React.useRef(0);

    React.useEffect(() => {
        function tick() {
            index.current++;
            setPlaceholder((prev: string) => prev + " " + text.split(" ")[index.current]);
        }
        if (index.current < text.split(" ").length - 1) {
            let addWord = setInterval(tick, speed);
            return () => clearInterval(addWord);
        }
    }, [placeholder, speed, text]);

    let newText = placeholder.split('\n').map(i => {
        return <p>{i}</p>
    });

    return <div>{newText}</div>
}

export default SlowText;

